import React from 'react';

/**
 * Wrapper component to ensure consistent styling across Extended Warranty screens
 * Provides the same padding and layout structure as Insurance Profile screens
 */
const ExtendedWarrantyScreenWrapper = ({ children, className = "" }) => {
  return (
    <div className={`space-y-8 p-4 pt-5 pb-6 ${className}`}>
      {children}
    </div>
  );
};

/**
 * Header component with consistent styling for Extended Warranty screens
 */
export const ExtendedWarrantyHeader = ({ 
  title, 
  subtitle, 
  icon, 
  children,
  className = "" 
}) => {
  return (
    <div className={`text-center bg-white p-2 rounded-[20px] space-y-4 ${className}`}>
      {icon && (
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
          {icon}
        </div>
      )}
      {title && (
        <h1 className=" text-2xl font-bold text-gray-900">
          {title}
        </h1>
      )}
      {subtitle && (
        <p className="text-lg text-gray-600">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};

/**
 * Card component with consistent styling for Extended Warranty screens
 */
export const ExtendedWarrantyCard = ({ 
  children, 
  variant = "default", 
  className = "" 
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case "info":
        return "bg-greenish border-none rounded-[20px]";
      case "success":
        return "bg-greenish border-none rounded-[20px]";
      case "error":
        return "bg-red-50 border-none rounded-[20px]";
      default:
        return "bg-white border-none rounded-[20px]";
    }
  };

  return (
    <div className={`${getVariantStyles()} ${className}`}>
      <div className="p-5">
        {children}
      </div>
    </div>
  );
};

/**
 * Button component with consistent styling for Extended Warranty screens
 */
export const ExtendedWarrantyButton = ({ 
  children, 
  onClick, 
  variant = "primary", 
  disabled = false, 
  className = "",
  ...props 
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case "secondary":
        return "bg-gray-600 hover:bg-gray-700";
      case "outline":
        return "border border-gray-300 text-gray-700 hover:bg-gray-50";
      default:
        return "bg-ownli hover:brightness-90";
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-fit mx-auto flex uppercase font-bold text-sm items-center justify-center gap-2 text-white px-4 py-3 rounded-[16px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${getVariantStyles()} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default ExtendedWarrantyScreenWrapper;
